import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { TranceProvider } from './components/TranceContext';
import { DataProvider } from './components/DataContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Events from './components/Events';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

// Pages
import About from './pages/About';
import Releases from './pages/Releases';
import Contact from './pages/Contact';
import TrancePage from './pages/TrancePage';
import NewTrancePage from './pages/NewTrancePage';
import CosmicPage from './pages/CosmicPage';
import QuantumPage from './pages/QuantumPage';
import ShroomsPage from './pages/ShroomsPage';
import CrusaderPage from './pages/CrusaderPage';

// Admin Components
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminAbout from './components/admin/AdminAbout';
import AdminReleases from './components/admin/AdminReleases';
import AdminEvents from './components/admin/AdminEvents';
import AdminMessages from './components/admin/AdminMessages';
import AdminLogin from './components/admin/AdminLogin';
import AdminSettings from './components/admin/AdminSettings';

// Layout wrapper for the main public site
const MainLayout = () => {
  return (
    <div className="min-h-screen bg-background text-foreground font-body selection:bg-primary selection:text-black flex flex-col">
      {/* TranceOverlay removed */}
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

// Home Page Component (Hero + Contact)
const HomePage = () => {
  const location = useLocation();

  // Handle hash scrolling when landing on the page
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Hero />
      <Events />
    </>
  );
};

// Wrapper for individual pages to ensure top padding under fixed navbar
const PageWrapper = ({ children }) => (
  <div className="pt-20 min-h-screen">
    {children}
  </div>
);

function App() {
  return (
    <Router>
      <DataProvider>
        <TranceProvider>
          <Routes>
            {/* Public Routes */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={
                <PageWrapper>
                  <About />
                </PageWrapper>
              } />
              <Route path="/releases" element={
                <PageWrapper>
                  <Releases />
                </PageWrapper>
              } />
              <Route path="/contact" element={
                <PageWrapper>
                  <Contact />
                </PageWrapper>
              } />
            </Route>
            
            {/* Party, Trance, Cosmic, Shrooms, LSD & Crusader Mode Routes (No Navbar/Footer) */}
            <Route path="/party" element={<TrancePage />} />
            <Route path="/trance" element={<NewTrancePage />} />
            <Route path="/cosmic" element={<CosmicPage />} />
            <Route path="/shrooms" element={<ShroomsPage />} />
            <Route path="/lsd" element={<QuantumPage />} />
            <Route path="/crusader" element={<CrusaderPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="about" element={<AdminAbout />} />
              <Route path="releases" element={<AdminReleases />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
          <Toaster />
        </TranceProvider>
      </DataProvider>
    </Router>
  );
}

export default App;
